@let optionsValue = options();
@let controls = selections().controls;

@for (option of optionsValue; track $index; let i = $index) {
  <div
    class="multi-choice-field__option"
    [class.multi-choice-field__option--selected]="controls[i].value"
  >
    <rt-checkbox [formControl]="controls[i]" [fullWidthLabel]="true">
      <span class="multi-choice-field__option-title">{{ option.title }}</span>
    </rt-checkbox>
  </div>
}
